import * as React from 'react';
// components
import { Icon } from 'components/spaceKit';
// types
import { ColorScheme } from 'components/_UI/designSystem';
import { AsyncSelectProps } from '@sprinklr/spaceweb/asyncSelect/types';
// helpers
import { useTheme } from 'styled-components';

export const useSelectOverrides = (isLoading: boolean): AsyncSelectProps['overrides'] => {
    const theme: ColorScheme = useTheme();
    return React.useMemo(() => {
        const selectTheme = theme.select;
        const { background: backgroundColor } = selectTheme.control.default;
        return {
            Root: {
                props: {
                    'data-test-id': 'spacekit',
                },
                style: {
                    minWidth: '0px',
                },
            },
            Popover: {
                props: {
                    overrides: {
                        Body: {
                            props: {
                                'data-test-id': 'spacekit',
                            },
                        },
                    },
                },
            },
            SelectArrow: {
                style: () => {
                    return {
                        height: '10px',
                        width: '10px',
                        marginLeft: '12px',
                        fill: theme.icon.default.fill,
                    };
                },
            },
            ClearIcon: {
                component: ClearIconProps => <Icon {...ClearIconProps} size={'xs'} value={'x'} />,
            },
            OptionContent: {
                style: () => {
                    return { paddingLeft: 0 };
                },
            },
            ValueContainer: {
                style: () => {
                    return {
                        paddingTop: '7px',
                        paddingBottom: '7px',
                        opacity: isLoading ? 0 : 1,
                    };
                },
            },
            ControlContainer: {
                style: () => {
                    return {
                        backgroundColor,
                    };
                },
            },
            Tag: {
                props: {
                    overrides: {
                        Button: {
                            props: {
                                endEnhancer: props => <Icon {...props} size={'xs'} value={'x'} />,
                            },
                        },
                    },
                },
            },
        };
    }, [theme, isLoading]);
};
